<template>
  <div class="diagram  row-center">
    <div class="box">
      <div class="title">
        <span>变压器实时负载率</span>
        <div v-show="$store.getters.projectId == 1" style="float: right">
          <i><img src="../../../assets/img/blue.png" alt=""> 配电负载率</i>
          <i style="margin-left: 20px"><img src="../../../assets/img/yellow.png" alt=""> 光伏负载率</i>
        </div>
      </div>
      <div class="cont">
        <Charts id="chartOption1" :option="$store.getters.projectId == 1 ? chartOption1CH :chartOption1"></Charts>
        <!-- <div class="nothing" v-else></div> -->
      </div>
    </div>
    <div class="box">
      <div class="title">
        <span>实时负荷曲线</span>
        <!-- <el-dropdown trigger="click">
          <span class="el-dropdown-link">
          中心配电房<i class="el-icon-caret-bottom"></i>
          </span>
        </el-dropdown> -->
        <div v-show="$store.getters.projectId == 1" style="float: right">
          <i><img src="../../../assets/img/blue.png" alt=""> 市电</i>
          <i style="margin-left: 20px"><img src="../../../assets/img/yellow.png" alt=""> 余电上网</i>
        </div>
      </div>
      <div class="cont">
        <!-- <Charts id="chartOption2" v-if="today.length > 0 || yesterday.length >0" :option="chartOption2"></Charts> -->
        <Charts id="chartOption2" :option="$store.getters.projectId == 1 ? chartOption3CH : chartOption3"></Charts>
        <!-- <div class="nothing" v-else></div>  -->
      </div>
    </div>
  </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import {getAreaLoadCurve, getWorkloadTotalLine} from '../../../api/power'
import * as echarts from 'echarts';
import {subscribe} from '../../../mqtt/index'
import {dayStart, dayEnd} from '../../../util/DateUtil'

export default {
  props: ['allTransformers'],
  data() {
    return {
      temp: [],
      rang: "month",
      today: [],
      yesterday: [],
      test: {
        timeArr: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'],
        valArr: []
      },
      timer: null,
    };
  },
  components: {
    Charts
  },
  computed: {
    areaId() {
      return this.$store.getters.areaId == 80 ? 72 : this.$store.getters.areaId
    },
    loadArr() {
      let colorgraphic = new echarts.graphic.LinearGradient(
          0, 1, 0, 0, [{//只要修改前四个参数就ok
            offset: 0,
            color: 'rgba(56,196,161, 0.7)'
          }, //柱图渐变色
            {
              offset: 1,
              color: 'rgba(246,189,22, 0.7)'
            }
          ]
      )
      let colorgraphic2 = new echarts.graphic.LinearGradient(
          0, 1, 0, 0, [{//只要修改前四个参数就ok
            offset: 0,
            color: 'rgba(56,196,161, 0.7)'
          }, //柱图渐变色
            {
              offset: 0.5,
              color: 'rgba(246,189,22, 0.7)'
            },
            {
              offset: 1,
              color: '#FD4238'
            }
          ]
      )
      let datas = this.transformerLoad.values.map(item => {
        // let datas = [80].map(item =>{
        return item = {
          value: item,
          itemStyle: {
            color: item < 80 ? 'rgba(56,196,161, 0.7)' : item >= 80 && item <= 100 ? colorgraphic : colorgraphic2
          }
        }
      })
      return datas
    },
    chartOption1CH() {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> %</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: 'category',
          data: this.transformerLoad.device2,
          // show: false,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: "0%",
          right: "6%",
          bottom: "10%",
          top: "15%",
          containLabel: true,
        },
        // color: ["#5AD8A6"],
        yAxis: {
          type: 'value',
          max: 120,
          // min: 0,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        title: {
          text: '%',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        series: [
          {
            // barGap: '0%',
            data: this.transformerLoad.values.map(item => {
              // let datas = [80].map(item =>{
              return item = {
                value: item,
                itemStyle: {
                  color: '#5B8FF9'
                }
              }
            }),
            barWidth: this.loadArr.length == 1 ? 200 : '',
            type: 'bar',
            name: '配电负载率',
            label: {
              show: true,
              position: 'top',
              // color:'red'
              fontSize: 18,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    // color: '#5B8FF9',
                  },
                  label: {
                    show: true,
                    position: 'end'
                  }
                },
              },
            },
          },
          this.transformerLoad.values2[0] < 0 && {
            barGap: '-100%',
            data: this.transformerLoad.values2.map(item => {
              // let datas = [80].map(item =>{
              console.log(item)
              return item = {
                value: item,
                itemStyle: {
                  color: '#F6BD16'
                }
              }
            }),
            barWidth: this.loadArr.length == 1 ? 200 : '',
            type: 'bar',
            name: '光伏负载率',
            label: {
              show: true,
              position: 'bottom',
              // color:'red'
              fontSize: 18,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    color: '#5B8FF9',
                  },
                  label: {
                    show: true,
                    position: 'end'
                  }
                },
              },
            },
          }
        ]
      };
    },
    chartOption1() {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            // console.log(params);
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> %</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },

        },
        xAxis: {
          type: 'category',
          data: this.transformerLoad.device,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        color: ["#5AD8A6"],
        yAxis: {
          type: 'value',
          max: 120,
          min: 0,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        title: {
          text: '%',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        series: [
          {
            data: this.loadArr,
            barWidth: this.loadArr.length == 1 ? 200 : '',
            type: 'bar',
            name: '负载率',
            label: {
              show: true,
              position: 'top',
              // color:'red'
              fontSize: 18,
              formatter: function (params) {
                // console.log(params);
                return `${params.value} %`
              }
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    // 这儿设置的颜色是公共配置，如需单独配置，请在data里配置
                    // color: '#000',
                  },
                  label: {
                    show: true,
                    position: 'end'

                  }
                },
              },
              data: [
                {
                  name: 'Y 轴值为 100 的水平线',
                  yAxis: 80,
                  // 单独配置每条线的样式
                  lineStyle: {
                    color: '#F6BD16'
                  },
                  label: {
                    position: 'end',
                    formatter: '重载',
                    color: '#F6BD16'
                  },
                },
                {
                  name: 'Y 轴值为 100 的水平线',
                  yAxis: 100,
                  // 单独配置每条线的样式
                  label: {
                    position: 'end',
                    formatter: '过载',
                    color: '#FD4238'
                  },
                  lineStyle: {
                    color: '#FD4238'
                  }
                }
              ]
            },
          }
        ]
      };
    },
    chartOption2() {
      return {
        grid: {
          left: "0%",
          right: "3%",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        title: {
          text: 'kW',
          left: -5,// 距离左边位置
          top: -5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        color: ["#5B8FF9", "#5AD8A6"],
        legend: {
          x: "center", //可设定图例在左、右、居中
          itemHeight: 14,
          itemWidth: 14,
          itemGap: 30,
          textStyle: {
            fontSize: "16rem", //字体大小
          },
          icon: "rect",
          data: ["今日", "昨日"],
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kW</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.temp,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        yAxis: {
          max: 120,
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        series: [

          {
            data: this.today,
            type: "line",
            name: "今日",
            smooth: true,
            itemStyle: {
              color: "#5AD8A6",
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(90 ,216, 166,0.4)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(90 ,216, 166,0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
          },
          {
            data: this.yesterday,
            type: "line",
            name: "昨日",
            smooth: true,
            itemStyle: {
              color: "#5B8FF9",
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(91, 143, 249,0.4)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(91, 143, 249,0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
          },
        ],
      };
    },
    chartOption3() {
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        title: {
          text: 'kW',
          left: -5,// 距离左边位置
          top: 5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        color: ["#5B8FF9", "#5AD8A6"],
        legend: {
          x: "center", //可设定图例在左、右、居中
          itemHeight: 14,
          itemWidth: 14,
          itemGap: 30,
          textStyle: {
            fontSize: "16rem", //字体大小
          },
          icon: "rect",
          data: ["实时负荷"],
          show: false
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kW</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.test.timeArr,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        yAxis: {
          max: this.test.valArr.length > 0 ? null : 120,
          min: 0,
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },

          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        series: [

          {
            data: this.test.valArr,
            type: "line",
            name: "实时负荷",
            // smooth: true,
            symbol: 'none',
            itemStyle: {
              color: "#5B8FF9",
            },
            step: 'end',
            markPoint: {
              symbol: 'pin',
              symbolSize: 20,
              data: [
                {type: 'max', name: 'Max'},
                // { type: 'min', name: 'Min' }
              ],
              label: {
                position: 'top',
                fontSize: 14,
                formatter: function (params) {
                  // console.log(params);
                  return `${params.value} kW`
                }
              }
            },
          },
        ],
      };
    },
    chartOption3CH() {
      return {
        grid: {
          left: "0%",
          right: "6%",
          bottom: "0%",
          top: "20%",
          containLabel: true,
        },
        title: {
          text: 'kW',
          left: -5,// 距离左边位置
          top: 5,// 距离上面位置
          textStyle: {
            fontWeight: 'bold',
            fontSize: 12,
            fontStyle: 'italic'
          }
        },
        color: ["#5B8FF9", "#5AD8A6", "#F6BD16"],
        legend: {
          x: "center", //可设定图例在左、右、居中
          itemHeight: 14,
          itemWidth: 14,
          itemGap: 30,
          textStyle: {
            fontSize: "16rem", //字体大小
          },
          icon: "rect",
          data: ["实时负荷"],
          show: false
        },
        visualMap: [{
          show: false,
          pieces: [{
            gt: 0,
            lte: 1000,
            color: '#5B8FF9'
          }, {
            lte: 0,
            color: '#F6BD16'
          }],
          seriesIndex: 0
        }],
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            let str = `${params[0].name}<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.value >= 0 ? '配电实时负荷' : '光伏实时负荷'}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> kW</b>`;
              str += idx === params.length - 1 ? '' : '<br/>'
            })
            return str
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.test.timeArr,
          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        yAxis: {
          max: this.test.valArr.length > 0 ? null : 120,
          // min: 0,
          type: "value",
          nameTextStyle: {
            align: "left",
            padding: [0, 0, 0, 24],
            fontSize: 16,
            color: "#333",
          },

          axisLabel: {
            fontSize: 12,
            fontWeight: 'bold'
          }
        },
        series: [
          {
            data: this.test.valArr,
            type: "line",
            name: "实时负荷",
            // smooth: true,
            symbol: 'none',
            itemStyle: {
              // color: "#5B8FF9",
              color: function (params) {
                if (params.value * 1 >= 0) {
                  return "#5B8FF9";
                }
                return "#F6BD16";
              },
            },
            step: 'end',
            markPoint: {
              symbol: 'pin',
              symbolSize: 20,
              data: [
                {type: 'max', name: 'Max'},
                // { type: 'min', name: 'Min' }
              ],
              label: {
                position: 'top',
                fontSize: 14,
                formatter: function (params) {
                  // console.log(params);
                  return `${params.value} kW`
                }
              }
            },
          },
        ],
      };
    },
    mqttval() {
      return this.getMqttVal(this.$store.getters.mqttVal);
    },
    transformerLoad() {
      let arr = []
      let arr2 = []
      let device = []
      let device2 = []
      // if(this.$store.getters.projectId==1){
      // 	let current = this.$store.state.project.transformerList.filter(item =>item.area_id == this.$store.getters.areaId)
      // 	current.forEach(item =>{
      // 		let la = this.mqttval(item.subLoopUrl +'/Ia')
      // 		let Ib = this.mqttval(item.subLoopUrl +'/Ib')
      // 		let Ic = this.mqttval(item.subLoopUrl +'/Ic')

      // 		let a = la == '--'?0:Number(la)
      //         let b = Ib == '--'?0:Number(Ib)
      //         let c = Ic == '--'?0:Number(Ic)
      // 		let zong = la == '--' &&  Ib == '--' && Ic == '--'?'--': a + b + c;
      // 		let v = zong == '--'?'--': zong/3/(parseFloat(JSON.parse(item.device_details)['电气']['容量'])*1000/400/Math.sqrt(3))*100;


      // 		arr.push(v=='--'?'--': v.toFixed(2))
      // 		device.push(item.deviceName)
      // 	})
      // }else{
      let current = this.$store.state.project.transformerList.filter(item => item.area_id == this.areaId).sort((a, b) => a.deviceName.replace('变压器T', '') - b.deviceName.replace('变压器T', ''))
      if (this.$store.getters.areaId == 75) {
        current.forEach(item => {
          let val = this.mqttval(item.subLoopUrl + '/PA')
          let v = Number(Math.abs(val)) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
          arr.push(val == '--' ? '--' : v.toFixed(2))
          device.push(item.deviceName)
        })
      } else {
        if (this.$store.getters.projectId == 1) {
          // 光伏
          current.forEach(item => {
            let val = this.mqttval('T1/1AA1/3WL/P')
            console.log("val", val)
            // if (val < 0) {
            let v = Number(val) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
            // let v = -19.5
            arr2.push(val == '--' ? '--' : v.toFixed(2))
            // }
            console.log(val, parseFloat(JSON.parse(item.device_details)['电气']['容量']), "parseFloat(JSON.parse(item.device_details)['电气']['容量'])")
            // device.push(item.deviceName)
          })
          // 配电
          current.forEach(item => {
            let val = this.mqttval(item.subLoopUrl + '/P')
            let v = Number(Math.abs(val)) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
            arr.push(val == '--' ? '--' : v.toFixed(2))
            device2.push(item.deviceName)
          })
        } else {
          current.forEach(item => {
            let val = this.mqttval(item.subLoopUrl + '/P')
            let v = Number(Math.abs(val)) / 10 / parseFloat(JSON.parse(item.device_details)['电气']['容量']).toFixed(2)
            arr.push(val == '--' ? '--' : v.toFixed(2))
            device.push(item.deviceName)
          })
        }

      }

      // }
      if (arr.length > 0) {
        return {
          values: arr,
          values2: arr2,
          device,
          device2
        }
      } else {
        return {
          values: [],
          values2: [],
          device: ['--'],
          device2: ['--'],
        }
      }

    },

  },
  watch: {
    '$store.getters.areaId'(areaId) {
      this.getLoadCurve()
    }
  },
  mounted() {
    let _this = this
    this.temp = []
    for (let i = 0; i <= 24; i++) {
      this.temp.push(i + "点");
    }

    // this.getLoadCurve()
    this.getList()
    this.timer = setInterval(() => {
      _this.getList()
    }, 300 * 1000)
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }

  },
  methods: {
    async getLoadCurve() {
      let res = await getAreaLoadCurve({
        areaId: this.areaId
      })
      if (res.data.code == 200) {
        this.today = Object.values(res.data.data.today).map(item => item = item / 1000)
        this.yesterday = Object.values(res.data.data.yesterday).map(item => item = item / 1000)

      } else {
        // console.log(res.data.errMsg);
      }
    },
    async getList() {
      let today = dayStart(new Date())
      let yesterday = dayEnd(new Date())

      let res = await getWorkloadTotalLine({
        start: today,
        end: yesterday,
        group: '5m',
        projectId: this.$store.getters.projectId
      })
      console.log(res)
      let timeArr = []
      let valArr = []
      res.data.data.forEach(item => {
        if (item.val !== '') {
          timeArr.push(item.time.split('T')[1].substr(0, 5))
          valArr.push(Number(item.val / 1000).toFixed(2))
        }
      })
      this.test = {
        timeArr, valArr
      }
    },
    getMqttVal(f) {
      return (k, m) => {
        if (k) {
          let mqttVal = f(k);
          if (m) {
            mqttVal *= m;
          }
          mqttVal = Number(mqttVal).toFixed(2);
          if (typeof mqttVal === "object") {
            return mqttVal;
          }
          return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
        } else {
          return "--";
        }
      };
    },
  }
};
</script>
<style lang="less" scoped>
.diagram {
  height: 100%;
  justify-content: space-between;

  .box {
    background: #ffffff;
    .w(592);
    height: 100%;
    padding: 18rem;
  }

  .title {
    font-size: 16rem;
    font-weight: bold;
    margin-bottom: 10rem;
  }

  .el-dropdown {
    color: #333;
    float: right;
    font-weight: 400;
    cursor: pointer;

    .el-dropdown-link {
      i {
        font-size: 24rem;
        vertical-align: middle;
      }
    }
  }

  .cont {
    justify-content: space-between;
    .h(250);
    width: 100%;
    position: relative;

    .nothing {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 55%;
      height: 60%;
      background: url('../../../assets/img/not_found_data.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>